import { render, staticRenderFns } from "./yian-study.vue?vue&type=template&id=16a84c16&scoped=true&"
import script from "./yian-study.vue?vue&type=script&lang=ts&"
export * from "./yian-study.vue?vue&type=script&lang=ts&"
import style0 from "./yian-study.vue?vue&type=style&index=0&id=16a84c16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a84c16",
  null
  
)

export default component.exports